<template>
  <div class="reim-info">
    <!-- :style="{ height: (7.168 + ((height + 80) / 42.875)) + 'rem' }" -->
    <div class="header-g" :style="{ height: (height) + 'px' }">
      <div ref="rejectReason" v-if="reimInfo.reimStatus" :class="['reim-info-header', getHeaderColor(reimInfo.reimStatus)]">
        <l-header></l-header>
        <div v-if="reimInfo.reimAmount" class="money">{{Number(reimInfo.reimAmount).toFixed(2)}}</div>
        <div class="bottom">
          <div><span class="icon huisuiyunfont">{{'\ue635'}}</span><span>{{reimInfo.reimNo}}</span></div>
          <div><span class="icon huisuiyunfont">{{'\ue632'}}</span><span>{{reimInfo.submitTime}}</span></div>
        </div>
        <div v-if="Number(reimInfo.reimStatus) === 1" class="state huisuiyunfont">
          {{'\ue638'}}
        </div>
        <div v-else-if="Number(reimInfo.reimStatus) === 2" class="state huisuiyunfont">
          {{'\ue637'}}
        </div>
        <div v-else class="state huisuiyunfont">
          {{'\ue636'}}
        </div>
        <div v-if="reimInfo.rejectReason" class="reject-reason">
          驳回原因: {{ reimInfo.rejectReason || '--'}}
        </div>
        <div v-if="!stickyShow" class="massage-title">
          <van-tabs v-model="headActive" title-active-color="#3378FF" title-inactive-color="#7A8699">
            <van-tab class="select">
              <template #title>
                <div class="tab-title">
                  <div>基本信息</div>
                </div>
              </template>
            </van-tab>
            <van-tab class="select">
              <template #title>
                <div class="tab-title">
                  <div>审批流程</div>
                </div>
              </template>
            </van-tab>
          </van-tabs>
        </div>
      </div>
    </div>
    <div v-if="headActive === 0" class="content">
      <div class="massage">
        <div>
          <div class="label">报销人</div>
          <div class="answer">{{reimInfo.reimApplicant}}</div>
        </div>
        <div>
          <div class="label">报销事由</div>
          <div class="answer">{{reimInfo.reimReason}}</div>
        </div>
        <div>
          <div class="label">备注</div>
          <div class="answer">{{reimInfo.remark ? reimInfo.remark : '--'}}</div>
        </div>
        <div>
          <div class="label">费用类型</div>
          <div class="answer">{{reimInfo.expenseTypeValue ? reimInfo.expenseTypeValue : '--'}}</div>
        </div>
      </div>
      <div class="tab-list">
          <div class="sticky-div">
            <van-sticky :offset-top="height - 49" @change="handleChange" >
              <van-tabs v-model="active" title-active-color="#3378FF" title-inactive-color="#7A8699">
                <van-tab class="select">
                  <template #title>
                    <div class="tab-title">
                      <div>发票</div>
                      <div :class="['tab-list-num', active === 0 ? 'select-tab-num' : '']">{{reimInfo.invoiceInfos ? reimInfo.invoiceInfos.length : '0'}}</div>
                    </div>
                  </template>
                </van-tab>
                <van-tab class="select">
                  <template #title>
                    <div class="tab-title">
                      <div>附件</div>
                      <div :class="['tab-list-num', active === 1 ? 'select-tab-num' : '']">{{fileList.length}}</div>
                    </div>
                  </template>
                </van-tab>
              </van-tabs>
              <div v-if="active === 0" :class="['sticky-tips',stickyShow ? 'big-sticky-tips' : '' ]">
                <div>共关联 {{reimInfo.invoiceInfos ? reimInfo.invoiceInfos.length : '0'}} 张发票，合计金额 {{Number(getSum).toFixed(2)}} 元</div>
                <div></div>
              </div>
              <div v-else-if="active === 1" :class="['sticky-tips',stickyShow ? 'big-sticky-tips' : '' ]">
                <div>共关联 {{fileList.length}} 个附件</div>
                <div></div>
              </div>
            </van-sticky>
          </div>
          <div v-if="active === 0" class="tab-content">
            <div v-for="(item, index) in reimInfo.invoiceInfos" :key="index" @click="handleGoInfo(item)">
              <div class="card">
                <div class="card-top">
                  <div class="no" v-if="item.exceptionInfo != '0' && item.exceptionInfo != null">异</div>
                  <div class="ok" v-else>验</div>
                  <div :class="['type' ,getColor(item.invoiceType)]">{{getType(item.invoiceType)}}</div>
                  <!-- item.purchaserName ? item.purchaserName : '--' -->
                  <div class="card-top-name">{{getTitle(item)}}</div>
                </div>
                <div class="card-bottom">
                  <div>{{item.drewDate ? item.drewDate : item.createTime ? item.createTime.split(' ')[0] : ''}}</div>
                  <div></div>
                  <div class="first-goods-name" v-if="item.invoiceType === '207'">{{ item.mileage+'km'}}</div>
                  <div class="first-goods-name" v-else-if="(item.invoiceType === '202')">{{item.agentCode}}</div>
                  <div class="first-goods-name" v-else-if="(item.invoiceType === '201')">{{item.trainNumber}}</div>
                  <div class="first-goods-name" v-else>{{item.firstGoodsName ? item.firstGoodsName : '--'}}</div>
                  <div>{{Number(item.amountWithTax).toFixed(2)}}</div>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="active === 1" class="tab-content">
            <div class="uoloader">
              <van-uploader v-model="fileList" disabled :deletable='false'/>
            </div>
          </div>
      </div>
    </div>
    <div v-else>
      <div v-if="examineInfo && examineInfo.nodeList" :active="examineInfo.nodeList.length" class="tab-content">
        <van-steps direction="vertical" active="100000" active-color="rgba(0,0,0,.85)">
          <van-step v-for="(item, index) in examineInfo.nodeList" :key="item.id">
            <template slot="inactive-icon">
              <div class="left-head">
                {{ joinHandlerName(item.nodeHandlerList || [], item.approvalType).split('')[0] }}
              </div>
            </template>
            <header class="step-head">
              <h3>{{ index === 0 ? '发起审批' : '审批' }}</h3>
              <p>{{ item.status === 'RUNNING' ? '' : item.updateTime || '' }}</p>
            </header>
            <main class="step-main">
              <div v-if="index === 0">
                <span>{{ joinHandlerName(item.nodeHandlerList || [], item.approvalType, index, item) + '提交单据' }}</span>
              </div>
<!--           节点正在审核, 正在审核前面需要增加"待"-->
              <div v-else-if="item.status === 'RUNNING'">
                <span>{{'待 ' + joinHandlerName(item.nodeHandlerList || [], item.approvalType, index, item) }}</span>
              </div>
              <div v-else>
                <div class="single-item">
                  <span>{{ joinHandlerName(item.nodeHandlerList || [], item.approvalType) }}</span>
                  <span>
                    <StatusTag
                      :customStyle="{ margin: '0 0 0 6px' }"
                      :haveRgbaBgColor="true"
                      :type="getHandlerResultClassMap(item.nodeHandlerList[0].result)"
                    >
                      {{ getMainResultTextMap[item.nodeHandlerList[0].result] }}
                    </StatusTag>
                  </span>
                </div>
                <div class="msg" v-if="item.nodeHandlerList.length === 1">
                  {{ item.nodeHandlerList[0].comment || '' }}
                </div>
              </div>
            </main>
          </van-step>
        </van-steps>
      </div>
      <van-empty v-else description="暂无数据" />
    </div>
    <div v-if="reimInfo.reimStatus !== 2" class="footer-btn">
      <div @click="handleDel">删除</div>
      <div @click="handleEdit(reimInfo.reimNo)">修改报销</div>
    </div>
  </div>
</template>
<script>
import { getInvoiceType, getInvoiceColor, getQuery } from '@utils/basicUtil'
import Header from '@/components/Header/index.vue'
import StatusTag from '@/components/StatusTag/index.vue'
// import moment from 'moment'
import { Sticky, PullRefresh, List, Notify, Empty, Tab, Tabs, Uploader, Step, Steps } from 'vant'
import { mapState, mapActions } from 'vuex'
// 待办结果，UNHANDLED未处理，AGREE同意，REJECT驳回，REFERRAL转审，REVOKE撤回，ABO
const handlerResultMap = {
  'AGREE': '已通过'
}
/**
 * 审批类型映射 审批类型: 或签、会签、依次审批
 */
const examineTypeMap = {
  'OR_SIGN': '或签',
  'COUNTERSION': '会签',
  'APPROVE_IN_SEQUENCE': '依次审批'
}
// 待办结果，UNHANDLED未处理，AGREE同意，REJECT驳回，REFERRAL转审，REVOKE撤回，ABO
const handlerResultClassMap = {
  'UNHANDLED': 'warning',
  'AGREE': 'success',
  'REJECT': 'error',
  'REFERRAL': 'warning',
  'REVOKE': 'error'
}
// 待办结果，UNHANDLED未处理，AGREE同意，REJECT驳回，REFERRAL转审，REVOKE撤回，ABO
const mainResultTextMap = {
  'UNHANDLED': '未处理',
  'AGREE': '审批通过',
  'REJECT': '审批驳回',
  'FINISHED': '已完成',
  'REFERRAL': '已转审',
  'REVOKE': '审批撤回'
}
export default {
  components: {
    'l-header': Header,
    [Sticky.name]: Sticky,
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [Notify.name]: Notify,
    [Empty.name]: Empty,
    [Tab.name]: Tab,
    [Steps.name]: Steps,
    [Tabs.name]: Tabs,
    [Step.name]: Step,
    StatusTag,
    [Uploader.name]: Uploader
  },
  data () {
    return {
      height: 0,
      active: 0,
      headActive: 0,
      files: [],
      stickyShow: false,
      columns: ['办公', '餐饮', '通讯', '飞机', '火车', '巴士', '打车', '住宿', '餐补', '里程', '娱乐', '福利', '快递', '其他'],
      show: false,
      fileList: [
        { url: 'https://img01.yzcdn.cn/vant/leaf.jpg' },
        { url: 'https://img01.yzcdn.cn/vant/leaf.jpg' },
        { url: 'https://img01.yzcdn.cn/vant/leaf.jpg' },
        { url: 'https://img01.yzcdn.cn/vant/leaf.jpg' }
      ]
    }
  },
  computed: {
    ...mapState('reimModels', ['reimInfo', 'examineInfo']),
    getMainResultTextMap () {
      return mainResultTextMap
    },
    getTitle () {
      return (item) => {
        if (item.sellerName) {
          return item.sellerName
        } else if (item.invoiceType === '200') {
          return '国家税务局通用定额发票'
        } else if (item.invoiceType === '202') {
          return item.issueBy
        } else if (item.place) {
          return item.place
        } else {
          return item.stationGetOn + ' - ' + item.stationGetOff
        }
      }
    },
    getType () {
      return (item) => {
        return getInvoiceType(item)
      }
    },
    getColor () {
      return (item) => {
        return getInvoiceColor(item)
      }
    },
    getHeaderColor () {
      return (i) => {
        let item = Number(i)
        if (item === 1) {
          return 'header-padding'
        } else if (item === 3) {
          return 'header-back'
        }
      }
    },
    getSum () {
      let sum = 0.00
      if (this.reimInfo.invoiceInfos) {
        if (this.reimInfo.invoiceInfos.length > 0) {
          this.reimInfo.invoiceInfos.map(i => {
            sum += Number(i.amountWithTax)
          })
        }
      }
      return sum
    }
  },
  methods: {
    ...mapActions('reimModels', ['getReimInfo', 'delReimById', 'getExamineInfo']),
    getHandlerResultClassMap (result) {
      return handlerResultClassMap[result]
    },
    /**
     * @description 根据approvalType获取文字
     * @param list
     * @param approvalType
     * @return {string} 返回join好的名称
     */
    joinHandlerName (list, approvalType, index, item) {
      const text = []
      // 状态文字
      const getStatusText = (i) => {
        if (item && item.status === 'RUNNING') return (handlerResultMap[i.result] && index !== 0) ? `(${handlerResultMap[i.result]})` : ''
        return ''
      }
      list.forEach(i => {
        text.push(`${(i.handlerName || '')}${getStatusText(i)}`)
      })

      // 拼接审批方式文案
      if (examineTypeMap[(approvalType + '')] && list.length !== 1) {
        return text.join('、') + (examineTypeMap[(approvalType + '')] ? ` ${examineTypeMap[(approvalType + '')]}` : '')
      }

      return text.join('、')
    },
    handleGoInfo (item) {
      switch (item.invoiceType) {
        case '201':
          this.$router.push({
            path: '/normal-travel/index',
            query: { id: item.id, type: '201', time: item.createTime, no: item.invoiceNo }
          })
          break
        case '202':
          this.$router.push({
            path: '/normal-travel/index',
            query: { id: item.id, type: '202', time: item.createTime, no: item.invoiceNo }
          })
          break
        case '207':
          this.$router.push({
            path: '/normal-travel/index',
            query: { id: item.id, type: '207', time: item.createTime, no: item.invoiceNo }
          })
          break
        case '200':
          this.$router.push({
            path: '/normed/index',
            query: { id: item.id, exceptionInfo: item.exceptionInfo, time: item.createTime, no: item.invoiceNo }
          })
          break
        case '51':
          this.$router.push({
            path: '/electricity-travel/index',
            query: { id: item.id, exceptionInfo: item.exceptionInfo, time: item.createTime, source: item.invoiceSource, code: item.invoiceCode, no: item.invoiceNo }
          })
          break
        case '61':
          this.$router.push({
            path: '/electricity-travel/index',
            query: { id: item.id, exceptionInfo: item.exceptionInfo, time: item.createTime, source: item.invoiceSource, code: item.invoiceCode, no: item.invoiceNo }
          })
          break
        default:
          console.log(item)
          this.$router.push({
            path: '/electricity/index',
            query: { id: item.id, exceptionInfo: item.exceptionInfo, time: item.createTime, source: item.invoiceSource, code: item.invoiceCode, no: item.invoiceNo }
          })
          break
      }
    },
    handleChange () {
      this.stickyShow = !this.stickyShow
    },
    onInputChange ({ e, field }) {
      console.log(e, field)
    },
    handleEdit (id) {
      sessionStorage.clear()
      this.$router.push({ path: '/reimbursement/launch-reim', query: { id } })
    },
    async handleDel () {
      await this.delReimById(this.reimInfo.reimNo)
      this.$router.go(-1)
    },
    finishUploadFile (result) {
      if (result.code === '200') {
        console.log(result)
        // let res = [
        //   ...this.formData.files
        // ]
        // const target = {
        //   url: result.fileUrl
        // }
        // res.push(target)
        // this.changeApply({
        //   files: res
        // })
      } else {
        Notify({ type: 'danger', message: result.message })
      }
    },
    deletePic (file) {
      // let res = this.formData.files.filter(item => item.url !== file.url)
      // this.changeApply({
      //   files: res
      // })
    }
  },
  async mounted () {
    let id = getQuery()
    this.fileList = []
    await this.getReimInfo(id.id)
    await this.getExamineInfo(id.id)
    this.reimInfo.attachmentInfos.map(item => {
      let obj = {}
      obj.url = item.fileDirectory
      this.fileList.push(obj)
    })
    this.height = this.$refs['rejectReason'] ? this.$refs['rejectReason'].offsetHeight : 0
  }
}
</script>
<style scoped src="./style.less" lang="less"></style>
